import {
    REQUEST_DRONE_MAINTENANCE,
    RECEIVE_DRONE_MAINTENANCE,
    UPDATE_DRONE_MAINTENANCE,
    ERROR_DRONE_MAINTENANCE
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_DRONE_MAINTENANCE
    };
}

export function receive(data) {
    return {
        type: RECEIVE_DRONE_MAINTENANCE,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_DRONE_MAINTENANCE,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_DRONE_MAINTENANCE,
        id,
        payload: data,
        updateType
    }
}

export function getDroneMaintenanceList(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().droneMaintenance, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'drone-maintenance',
                params: prepareFilters(params, getState(), "droneMaintenance")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getDroneMaintenance(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('droneMaintenance'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'drone-maintenance/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createDroneMaintenance(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'drone-maintenance',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateDroneMaintenance(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('droneMaintenance'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'drone-maintenance/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteDroneMaintenance(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'drone-maintenance/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}